class SearchModel {
  constructor(id,email,imgurl,followNub) {
    this.id = id;
    this.email = email;
    this.imgurl = imgurl;
    this.followNub = followNub;
  }
}
export default SearchModel;
